import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import RangeDetail from './components/RangeDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageRange',
  components: {
    RangeDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;